import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SendEmailService {


  constructor(private http: HttpClient) { }
 
   url = environment.serverAPI4 + "/api";
   
   sendEmail(mail:any): Observable<Response[]> {
     return this.http.post<Response[]>(`${this.url}/sendMail`, mail);
   }
 }
 